<template>
  <div class="text-white">
    <div class="max-w-5xl mx-auto px-6 py-10">
      <div class="mb-8">
        <h1 class="text-3xl font-bold mb-3">Indique e Ganhe!</h1>
        <p class="text-[#9CA3AF] leading-relaxed text-sm">
          Indique alguém para o BOT EXPRESS e receba uma comissão sobre cada venda realizada por essa pessoa.
          O melhor de tudo é que sua comissão vem das taxas da plataforma, sem impactar os ganhos de quem você indicar. 
          A cada transação concluída pelo indicado, você recebe 
          <span v-if="paymentGatewayIntegration" class="text-emerald-400">{{ paymentGatewayIntegration?.referralCommissionPercentage }}%</span> 
          <span v-else class="skeleton-shine animate-shimmer text-transparent">0%</span>  
          + 
          <span class="text-emerald-400" v-if="paymentGatewayIntegration">
            {{ paymentGatewayIntegration?.referralCommissionAmount?.toLocaleString('pt-BR', { currency: 'brl', style: 'currency' }) }}
          </span>
          <span v-else class="skeleton-shine animate-shimmer text-transparent">R$ 0,00</span>  
          do valor da venda.
          Aproveite essa oportunidade para aumentar sua renda.
        </p>
      </div>

      <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        <div class="bg-gradient-to-br from-white/5 to-white/10 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <Users class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Total de indicações</h3>
          </div>
          <p class="text-2xl font-bold">24</p>
        </div>
        
        <div class="bg-gradient-to-br from-white/5 to-white/10 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <Award class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Indicações convertidas</h3>
          </div>
          <div class="flex items-center">
            <p class="text-2xl font-bold">18</p>
            <span class="ml-2 bg-emerald-500/20 text-emerald-400 text-xs px-2 py-0.5 rounded-full">75%</span>
          </div>
        </div>
        
        <div class="bg-gradient-to-br from-white/5 to-white/10 rounded-xl p-5 backdrop-blur-sm">
          <div class="flex items-center mb-2">
            <DollarSign class="h-5 w-5 text-emerald-400 mr-2" />
            <h3 class="text-sm font-medium text-[#9CA3AF]">Recompensas ganhas</h3>
          </div>
          <p class="text-2xl font-bold">R$ 360,00</p>
        </div>
      </div> -->

      <div class="bg-gradient-to-br from-white/5 to-white/10 rounded-xl p-6 mb-10 backdrop-blur-sm">
        <h2 class="text-xl font-bold mb-2">Seu código de indicação</h2>
        <p class="text-[#9CA3AF] text-sm mb-4">
          Compartilhe este código com seus amigos e ganhe recompensas quando eles se cadastrarem.
        </p>
        
        <div class="flex items-center gap-2 bg-[#1A1A1A]/80 p-3 rounded-lg mb-3">
          <Gift class="h-5 w-5 text-emerald-400 mr-1" />
          <div v-if="paymentGatewayIntegration" class="text-xl font-bold tracking-wider text-sm">{{ paymentGatewayIntegration.organizationUUID }}</div>
          <div v-else class="skeleton-shine animate-shimmer w-[340px] h-8"></div>
          <button 
            @click="copyCode" 
            class="text-[#9CA3AF] hover:text-white p-1.5 rounded-md hover:bg-white/10 transition-colors"
          >
            <Check v-if="codeCopied" class="h-5 min-w-5 text-emerald-500" />
            <Copy v-else class="h-5 min-w-5" />
          </button>
        </div>
        
        <p class="text-[#9CA3AF] text-xs">Todos os convites são vitalícios.</p>
      </div>

      <!-- <div class="mt-10">
        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
          <h2 class="text-xl font-bold">Suas indicações</h2>
          
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <div class="relative w-full sm:w-auto">
              <Search class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#9CA3AF]" />
              <input 
                type="text" 
                placeholder="Buscar indicações..." 
                class="bg-[#1A1A1A] border-0 focus:ring-1 focus:ring-emerald-500 text-white rounded-md pl-10 pr-3 py-2 w-full"
              />
            </div>
          </div>
        </div>

        <div class="bg-gradient-to-br from-white/5 to-white/10 rounded-xl overflow-hidden backdrop-blur-sm">
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead>
                <tr class="border-b border-white/10">
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">NOME</th>
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">EMAIL</th>
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">DATA</th>
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">STATUS</th>
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">PLANO</th>
                  <th class="text-left p-4 text-[#9CA3AF] font-medium">RECOMPENSA</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(indicacao, index) in indicacoes" 
                  :key="index"
                  class="border-b border-white/10 hover:bg-white/5 transition-colors"
                  :class="{ 'border-b-0': index === indicacoes.length - 1 }"
                >
                  <td class="p-4">{{ indicacao.nome }}</td>
                  <td class="p-4">{{ indicacao.email }}</td>
                  <td class="p-4">{{ indicacao.data }}</td>
                  <td class="p-4">
                    <span 
                      class="px-2 py-0.5 rounded-full text-xs"
                      :class="{
                        'bg-emerald-500/20 text-emerald-400': indicacao.status === 'Convertido',
                        'bg-yellow-500/20 text-yellow-400': indicacao.status === 'Pendente',
                        'bg-red-500/20 text-red-400': indicacao.status === 'Expirado'
                      }"
                    >
                      {{ indicacao.status }}
                    </span>
                  </td>
                  <td class="p-4">{{ indicacao.plano || '-' }}</td>
                  <td class="p-4">{{ indicacao.recompensa || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="flex items-center justify-between p-4 border-t border-white/10">
            <div class="text-sm text-[#9CA3AF]">
              Mostrando 5 de 24 indicações
            </div>
            <button class="text-emerald-400 hover:text-emerald-300 text-sm font-medium transition-colors">
              Ver todas
            </button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Copy, Check, Award, Users, Search, Gift, DollarSign } from 'lucide-vue-next'
import { usePaymentGatewayIntegration } from '@/composables/usePaymentGatewayIntegration'
import { PaymentGatewayIntegration } from '@/interfaces/payment-gateway-integrations/PaymentGatewayIntegration'

// Animação de cópia do código
const { paymentGatewayIntegration } = usePaymentGatewayIntegration()
const codeCopied = ref(false)
const copyCode = () => {
  navigator.clipboard.writeText(paymentGatewayIntegration.value?.organizationUUID ?? '')
  codeCopied.value = true
  
  setTimeout(() => {
    codeCopied.value = false
  }, 2000)
}

// Dados de exemplo para a tabela
// const indicacoes = [
//   {
//     nome: 'João Silva',
//     email: 'joao.silva@email.com',
//     data: '12/03/2025',
//     status: 'Convertido',
//     plano: 'Plano Premium',
//     recompensa: 'R$ 20,00'
//   },
//   {
//     nome: 'Maria Oliveira',
//     email: 'maria.oliveira@email.com',
//     data: '10/03/2025',
//     status: 'Convertido',
//     plano: 'Plano Premium',
//     recompensa: 'R$ 20,00'
//   },
//   {
//     nome: 'Carlos Mendes',
//     email: 'carlos.mendes@email.com',
//     data: '08/03/2025',
//     status: 'Pendente',
//     plano: '',
//     recompensa: ''
//   },
//   {
//     nome: 'Ana Souza',
//     email: 'ana.souza@email.com',
//     data: '05/03/2025',
//     status: 'Convertido',
//     plano: 'Plano upsell',
//     recompensa: 'R$ 10,00'
//   },
//   {
//     nome: 'Pedro Costa',
//     email: 'pedro.costa@email.com',
//     data: '01/03/2025',
//     status: 'Expirado',
//     plano: '',
//     recompensa: ''
//   }
// ]
</script>

<style>
/* Transições suaves para elementos interativos */
.transition-colors {
  transition: all 0.2s ease;
}

/* Animação para o ícone de cópia */
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}

.text-emerald-500 {
  animation: fadeIn 0.3s ease;
}

/* Efeito de vidro fosco */
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
}
</style>